<template>
  <div>
    <px-view-header title="Cadastro de locais de entrega" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loadingCadastro">
      <px-circular-loading/>
    </div>
    <div v-if="!loadingCadastro" class="mt-3">
      <v-row dense>
        <v-col cols="12">
          <v-subheader class="body-1 grey lighten-4 text--primary">
            <v-icon>
              mdi-text-box-outline
            </v-icon>
            <span class="ml-2">Dados gerais</span>
          </v-subheader>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            outlined
            hide-details
            label="Nome do local"
            class="required rounded-tag-small"
            :error="$v.locaisEntrega.nomeLocal.$error"
            @blur="$v.locaisEntrega.nomeLocal.$touch()"
            v-model="locaisEntrega.nomeLocal"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <px-select-enum
            dense
            required
            class="required rounded-tag-small"
            label="Tipo de endereço"
            :items="tiposEndereco"
            v-model="locaisEntrega.tipo"
            @change="onChangeTipo"/>
        </v-col>
        <v-col cols="12" sm="2">
          <v-text-field
            dense
            outlined
            hide-details
            label="Código interno"
            class="rounded-tag-small"
            v-model="locaisEntrega.codigoInterno"
          />
        </v-col>
        <v-col cols="12" sm="1">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2 mr-2"
                    label="Ativo"
                    color="primary"
                    v-model="locaisEntrega.ativo"/>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="rounded-tag-small"
            label="Observações internas"
            counter="1500"
            rows="1"
            v-model="locaisEntrega.observacoesInternas"
          />
        </v-col>
      </v-row>
      <px-cadastro-endereco-nacional ref="nacional"
                                      v-if="isLocaisEntregaNacional"
                                      :endereco="locaisEntrega.endereco"
                                      @before-save="onBeforeSave"/>
      <px-cadastro-endereco-internacional ref="internacional"
                                          v-if="isLocaisEntregaInternacional"
                                          :endereco="locaisEntrega.endereco"
                                          @before-save="onBeforeSave"/>
      <v-row dense class="mt-2">
        <v-col cols="12">
          <v-btn class="elevation-0 normal-btn-text rounded-tag-small"
                 color="primary"
                 :disabled="loadingSave"
                 @click="onClickSave">
            Salvar
          </v-btn>
          <v-btn class="elevation-0 normal-btn-text rounded-tag-small ml-3"
                 @click="onClickBack">
            Cancelar
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import LocaisEntregaService from '@/modules/locais-entrega/locais-entrega-service';
import TipoEndereco from '@/enums/tipo-endereco';

export default {
  mixins: [validationMixin],
  data() {
    return {
      id: this.$route.params.id,
      loadingCadastro: false,
      loadingSave: false,
      locaisEntrega: {
        nomeLocal: null,
        codigoInterno: null,
        observacoesInternas: null,
        ativo: true,
        tipo: TipoEndereco.keys.NACIONAL.key,
        endereco: {
          estado: null,
          municipio: null,
          mesorregiao: null,
          cep: null,
          rua: null,
          numero: null,
          complemento: null,
          bairro: null,
          pais: null,
          codigoPostal: null,
          provincia: null,
          cidade: null,
        },
      },
      tiposEndereco: TipoEndereco.values,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Locais de entrega', to: '/locais-entrega' },
        { text: 'Cadastro' },
      ],
    };
  },
  computed: {
    isLocaisEntregaInternacional() {
      return this.locaisEntrega.tipo === TipoEndereco.keys.EXTERIOR.key;
    },
    isLocaisEntregaNacional() {
      return this.locaisEntrega.tipo === TipoEndereco.keys.NACIONAL.key;
    },
    isEdicao() {
      return !!this.id;
    },
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.locais-entrega' });
    },
    onChangeTipo() {
      this.locaisEntrega.endereco = {
        estado: null,
        municipio: null,
        mesorregiao: null,
        cep: null,
        rua: null,
        numero: null,
        complemento: null,
        bairro: null,
        pais: null,
        codigoPostal: null,
        provincia: null,
        cidade: null,
      };
    },
    onBeforeSave() {
      this.validateForm();
    },
    onClickSave() {
      if (this.validateForm()) {
        return;
      }
      if (this.isLocaisEntregaNacional && this.$refs.nacional.validateForm()) {
        return;
      }
      if (this.isLocaisEntregaInternacional && this.$refs.internacional.validateForm()) {
        return;
      }
      this.loadingSave = true;
      LocaisEntregaService.save(this.locaisEntrega)
        .then(() => {
          const successMessage = this.locaisEntrega.id
            ? 'Local de entrega atualizado'
            : 'Local de entrega criado';
          this.$toast(successMessage, { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    getLocaisEntrega() {
      this.loadingCadastro = true;
      LocaisEntregaService.get(this.id)
        .then((response) => {
          this.locaisEntrega = response.data;
        })
        .finally(() => {
          this.loadingCadastro = false;
        });
    },
  },
  created() {
    if (this.isEdicao) {
      this.getLocaisEntrega();
    }
  },
  validations: {
    locaisEntrega: {
      nomeLocal: {
        required,
      },
    },
  },
};
</script>
